import { Component, OnInit } from '@angular/core';
import { Platform, ModalController, AlertController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
import {
  IResponseDto,
  IReminderDto,
  ReminderPageVM
} from '../../models/common.models';
@Component({
  selector: 'app-reminder',
  templateUrl: './reminder.page.html',
  styleUrls: ['./reminder.page.scss'],
})
export class ReminderPage implements OnInit {
  currentModal = null;
  vm = ReminderPageVM;
  limit = 120;
  studentId;
  classname;
  apikey;
  // = sessionStorage.getItem('classname');
  constructor(
    private modalCtrl: ModalController,
    public router: Router,
    public commonSvc: CommonService,
    public dataSvc: DataService,
    public platform: Platform,
    public alertCtrl: AlertController,
  ) { }

  ngOnInit() {
    this.getStudentId().then(() => {
      if (this.studentId > 0 && this.classname) {
        this.getreminders();
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    });
  }
  async getStudentId() {
    this.studentId = + await this.commonSvc.getItem('studentid');
    this.classname = await this.commonSvc.getItem('classname');
    this.apikey = await this.commonSvc.getItem('apikey');
  }
  async ShowMoreContent(item) {
    const alert = await this.alertCtrl.create({
      // header: item.startDate,
      // subHeader: item.endDate,
      message: item.description,
      cssClass: 'origin',
      buttons: ['Ok']
    });
    await alert.present();
  }
  getReminderString(reminderString) {
    if (reminderString.length > this.limit) {
      reminderString = reminderString.substring(0, this.limit);
    }
    return reminderString;
  }
  async getreminders() {
    try {
      await this.commonSvc.showLoader();
      await this.dataSvc.reminders(this.classname).then((response: IResponseDto<IReminderDto[]>) => {
        this.commonSvc.hideLoader();
        if (response != null && response.status !== 'Error') {
          this.vm = response;
        } else {
          this.vm.message = response.message;
        }
        console.log(this.vm);
      });
    } catch (err) {
      console.log(JSON.stringify(err));
    }
    this.commonSvc.hideLoader();
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
